export const ROLES = {
  DEPARTMENT_HEAD: "Head of Commercial & Shipping",
  DIRECTOR: "Director",
  ACCOUNTS: "F&A",
};
